import React, {useContext, useState, useEffect} from 'react'
import {PublicContext} from '../../PublicContext'
import axios from 'axios'
import PaypalButton from './PaymentBtn'
import env from '../../settings'
import {showErrMsg, showSuccessMsg} from '../../Notifications/Notification'
import { Link } from 'react-router-dom'


function Cart() {
    const initialState = {
        err: '',
        success: ''
    }
    const [userZ, setUserZ] = useState(initialState)
    const { err, success} = userZ
    const state = useContext(PublicContext)
    const [cart, setCart] = state.userAPI.cart
    const [token] = state.token
    const [total, setTotal] = useState(0)

    useEffect(() =>{
        const getTotal = () =>{
            const total = cart.reduce((prev, item) => {
                return prev + (item.price * item.quantity)
            },0)

            setTotal(total)
        }

        getTotal()

    },[cart])

    const addToCart = async (cart) =>{
        await axios.put(`${env.api}/user/addcart`, {cart}, {
            headers: {Authorization: token}
        })
    }


    const increment = (id) =>{
        cart.forEach(item => {
            if(item._id === id){
                item.quantity += 1
            }
        })

        setCart([...cart])
        addToCart(cart)
    }

    const decrement = (id) =>{
        cart.forEach(item => {
            if(item._id === id){
                item.quantity === 1 ? item.quantity = 1 : item.quantity -= 1
            }
        })

        setCart([...cart])
        addToCart(cart)
    }

    const removeProduct = id =>{
        if(window.confirm("Do you want to delete this product?")){
            cart.forEach((item, index) => {
                if(item._id === id){
                    cart.splice(index, 1)
                }
            })

            setCart([...cart])
            addToCart(cart)
        }
    }

    const tranSuccess = async(payment) => {
        
        const {paymentID, address} = payment;

        await axios.post(`${env.api}/api/payment`, {cart, paymentID, address}, {
            headers: {Authorization: token}
        })

        setCart([])
        addToCart([])
        setUserZ({...userZ, err: '' , success: "YaY!!!You have successfully placed an order"})
        alert("You have successfully placed an order.")
    }


    if(cart.length === 0) 
        return <div>
            <img className="cartempty" src="https://www.webtoffee.com/wp-content/themes/webtoffee/assets/images/empty-cart.svg"></img>
            <Link to='/'><button className="ToshpBtn">Continue Shopping</button> </Link>
            <div className="cartemptyTxt" >Cart Empty</div> 
            </div>

    return (
        <>
        <br></br>
                        {err && showErrMsg(err)}
                        {success && showSuccessMsg(success)}
                        <br></br>
        <div>
            {
                cart.map(product => (
                    <div className="detail cart" key={product._id}>
                        <img src={product.images.url} alt="" />

                        <div className="box-detail">
                            <h2>{product.title}</h2>

                            <h3 className="cartDez1">$ {product.price * product.quantity}</h3>
                            <p className="cartDez">{product.description}</p>
                            <p className="cartDez">{product.content}</p>

                            <div className="amount">
                                <button onClick={() => decrement(product._id)}> - </button>
                                <span>{product.quantity}</span>
                                <button onClick={() => increment(product._id)}> + </button>
                            </div>
                            
                            <div className="delete" 
                            onClick={() => removeProduct(product._id)}>
                                X
                            </div>
                        </div>
                    </div>
                ))
            }

            <div className="total">
                <h3>Total: $ {total}</h3>
                <PaypalButton
                total={total}
                tranSuccess={tranSuccess} />
            </div>
        </div>
        </>
    )
}

export default Cart
